<template>
	<el-dialog v-dialogDrag class="group-member-selector-shell im-dialog-shell im-dialog-shell--lg" :title="title" :visible.sync="isShow" :width="dialogWidth"
		:before-close="close" custom-class="group-member-selector-dialog" top="4vh" append-to-body>
		<div class="group-member-selector" :class="{ 'is-mobile': isMobileView }">
			<div class="left-box">
				<div class="panel-head">
					<el-input placeholder="搜索成员昵称或完整账号" v-model="searchText" size="small" clearable>
						<i class="el-icon-search el-input__icon" slot="suffix"> </i>
					</el-input>
					<div class="select-tools">
						<el-checkbox
							v-model="allVisibleCheckedProxy"
							:indeterminate="isSelectAllIndeterminate"
							:disabled="selectableMemberTotalCount === 0"
						>
							全选
						</el-checkbox>
						<div class="select-tools__actions">
							<div class="result-badge">{{ selectableMemberTotalCount }}</div>
							<el-button
								type="text"
								icon="el-icon-delete"
								class="icon-btn clear-btn"
								:disabled="removableCheckedCount === 0"
								title="清空"
								@click="clearChecked"
							></el-button>
						</div>
					</div>
				</div>
				<empty-state
					v-if="showMembers.length === 0"
					class="scroll-box list-empty-state"
					icon="el-icon-search"
					:title="currentEmptyTitle"
					compact
				></empty-state>
				<virtual-scroller
					v-else
					class="scroll-box"
					:items="showMembers"
					:item-height="memberRowHeight"
					:item-key-getter="getCandidateRowKey"
					@reach-bottom="onMemberListReachBottom"
				>
					<template v-slot="{ item }">
						<group-member-bar :group="group" :member="item" :height="memberRowHeight"
							@click.native="onClickMember(item)">
							<el-checkbox :disabled="item.locked" :value="item.checked" @input="setMemberChecked(item, $event)"
								@click.native.stop=""></el-checkbox>
						</group-member-bar>
					</template>
				</virtual-scroller>
			</div>
			<div class="right-box">
				<div class="panel-head selection-head">
					<div class="panel-title compact-title">
						<i class="el-icon-user-solid"></i>
						<span>已选成员</span>
						<span class="inline-count">{{ checkCount }}</span>
					</div>
					<el-button
						v-if="checkedMembers.length > 0"
						type="text"
						icon="el-icon-delete"
						class="icon-btn clear-btn"
						:disabled="removableCheckedCount === 0"
						title="清空"
						@click="clearChecked"
					></el-button>
				</div>
				<empty-state
					v-if="checkedMembers.length === 0"
					class="scroll-box list-empty-state compact-empty"
					icon="el-icon-user"
					title="请选择要操作的成员"
					compact
				></empty-state>
					<virtual-scroller
						v-else
						class="scroll-box checked-scroll-box"
						:items="checkedMembersView"
						:item-height="58"
						:item-key-getter="getCheckedRowKey"
						@reach-bottom="onCheckedListReachBottom"
					>
					<template v-slot="{ item: m }">
						<div class="checked-item" @click="onClickMember(m)">
							<head-image :url="m.headImage" :name="m.showNickName" :size="34" :online="m.online"></head-image>
							<div class="checked-main">
								<div class="checked-name">{{ m.showNickName }}</div>
								<div class="checked-meta">
									<span v-if="m.userId == group.ownerId" class="state-tag danger">群主</span>
									<span v-else-if="m.isManager" class="state-tag">管理员</span>
									<span v-if="m.isMuted" class="state-tag warning">禁言</span>
								</div>
							</div>
							<div class="close" title="移除">
								<i class="el-icon-close"></i>
							</div>
						</div>
					</template>
				</virtual-scroller>
			</div>
		</div>
		<span slot="footer" class="dialog-footer selector-footer">
			<el-button @click="close()">取 消</el-button>
			<el-button type="primary" @click="ok()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import GroupMemberBar from './GroupMemberBar.vue';
import VirtualScroller from '../common/VirtualScroller.vue';
import { attachContactSearchText, matchesContactKeyword } from '../../utils/contactSearchMatcher';

const CANDIDATE_PAGE_LIMIT = 30;
const REMOTE_ACTIONS = new Set(['remove', 'mute', 'unmute']);
const AUTHORITATIVE_CANDIDATE_ACTIONS = new Set(['mute', 'unmute']);
const CHECKED_RESULT_PAGE_SIZE = 30;

function resolveIdKey(id) {
	return id === undefined || id === null || id === '' ? '' : String(id);
}

function normalizeCandidatePage(payload) {
	const page = payload && typeof payload === 'object' ? payload : {};
	return {
		items: Array.isArray(page.items) ? page.items : [],
		cursor: page.cursor ? String(page.cursor) : '',
		more: Boolean(page.more),
		total: Math.max(0, Math.floor(Number(page.total || 0)))
	};
}

export default {
	name: "groupMemberSelector",
	components: {
		HeadImage,
		GroupMemberBar,
		VirtualScroller
	},
	data() {
		return {
			isShow: false,
			searchText: "",
			maxSize: -1,
			members: [],
			selectedMap: Object.create(null),
			selectedItems: Object.create(null),
			excludedMap: Object.create(null),
			lockedMap: Object.create(null),
			hiddenMap: Object.create(null),
			allSelected: false,
			action: '',
				page: {
					cursor: '',
					more: false,
					total: 0,
					sourceTotal: 0,
					loading: false,
					loadingMore: false,
					keyword: ''
				},
				checkedViewLimit: CHECKED_RESULT_PAGE_SIZE,
				searchTimer: null,
				loadSeq: 0
			}
	},
	props: {
		group: {
			type: Object
		},
		title: {
			type: String,
			default: "选择成员"
		}
	},
		methods: {
			getCandidateRowKey(member) {
				const key = resolveIdKey(member && member.userId);
				return key ? `candidate:${key}` : '';
			},
			getCheckedRowKey(member) {
				const key = resolveIdKey(member && member.userId);
				return key ? `checked:${key}` : '';
			},
			open(maxSize, checkedIds, lockedIds, hideIds, options = {}) {
			this.resetState();
			this.maxSize = Number.isFinite(Number(maxSize)) ? Number(maxSize) : -1;
			this.action = options && options.action ? String(options.action) : '';
			this.lockedMap = this.toIdMap(lockedIds);
			this.hiddenMap = this.toIdMap(hideIds);
			(Array.isArray(checkedIds) ? checkedIds : []).forEach((id) => {
				const key = resolveIdKey(id);
				// 已锁定/隐藏成员不属于当前可选结果，不能计入已选数量或全选状态。
				if (key && !this.lockedMap[key] && !this.hiddenMap[key]) {
					this.$set(this.selectedMap, key, Number(id));
				}
			});
			this.isShow = true;
			this.loadMembers({ reset: true });
		},
		resetState() {
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
				this.searchTimer = null;
			}
			this.searchText = "";
			this.members = [];
			this.selectedMap = Object.create(null);
			this.selectedItems = Object.create(null);
			this.excludedMap = Object.create(null);
			this.lockedMap = Object.create(null);
			this.hiddenMap = Object.create(null);
			this.allSelected = false;
			this.action = '';
				this.page = {
					cursor: '',
					more: false,
					total: 0,
					sourceTotal: 0,
					loading: false,
					loadingMore: false,
					keyword: ''
				};
				this.checkedViewLimit = CHECKED_RESULT_PAGE_SIZE;
			},
		toIdMap(ids) {
			const map = Object.create(null);
			(Array.isArray(ids) ? ids : []).forEach((id) => {
				const key = resolveIdKey(id);
				if (key) {
					map[key] = Number(id);
				}
			});
			return map;
		},
		onClickMember(m) {
			this.setMemberChecked(m, !this.isMemberChecked(m));
		},
		setMemberChecked(m, checked) {
			if (!m || m.locked) {
				return;
			}
			const key = resolveIdKey(m.userId);
			if (!key) {
				return;
			}
			if (!this.allSelected && checked && !this.selectedMap[key] && this.maxSize > 0 && this.checkCount >= this.maxSize) {
				this.$message.error(`最多选择${this.maxSize}位成员`);
				return;
			}
			if (this.allSelected) {
				if (checked) {
					this.$delete(this.excludedMap, key);
				} else {
					this.$set(this.excludedMap, key, Number(m.userId));
				}
				} else if (checked) {
					this.$set(this.selectedMap, key, Number(m.userId));
					this.$set(this.selectedItems, key, m);
					if (this.selectedUserIds.length <= this.checkedViewLimit + 1) {
						this.checkedViewLimit = this.selectedUserIds.length;
					}
				} else {
					this.$delete(this.selectedMap, key);
					this.$delete(this.selectedItems, key);
			}
			m.checked = this.isMemberChecked(m);
		},
		isMemberChecked(member) {
			const key = resolveIdKey(member && member.userId);
			if (!key) {
				return false;
			}
			return this.allSelected ? !this.excludedMap[key] && !this.hiddenMap[key] && !this.lockedMap[key] : Boolean(this.selectedMap[key]);
		},
			clearChecked() {
				this.selectedMap = Object.create(null);
				this.selectedItems = Object.create(null);
				this.excludedMap = Object.create(null);
				this.allSelected = false;
				this.checkedViewLimit = CHECKED_RESULT_PAGE_SIZE;
				this.members.forEach((member) => {
					if (!member.locked) {
						member.checked = false;
				}
			});
		},
		async onToggleGlobalSelectAll(checked) {
			if (checked) {
				await this.ensureSourceTotal();
			}
			const sourceTotal = Math.max(0, Math.floor(Number(this.page.sourceTotal || this.page.total || 0)));
			if (checked && this.maxSize > 0 && sourceTotal > this.maxSize) {
				this.$message.error(`最多选择${this.maxSize}位成员`);
				return;
			}
			this.selectedMap = Object.create(null);
			this.selectedItems = Object.create(null);
			this.excludedMap = Object.create(null);
			this.allSelected = Boolean(checked);
			this.members.forEach((member) => {
				member.checked = this.isMemberChecked(member);
			});
			if (this.allSelected) {
				this.checkedViewLimit = CHECKED_RESULT_PAGE_SIZE;
				await this.ensureCheckedWindowHydratedForAllSelected();
			}
		},
		async ensureSourceTotal() {
			if (this.page.sourceTotal > 0 || (!this.normalizedSearchText && this.page.total >= 0)) {
				if (!this.normalizedSearchText) {
					this.page.sourceTotal = Math.max(0, Math.floor(Number(this.page.total || 0)));
				}
				return this.page.sourceTotal;
			}
			if (!this.canUseRemoteCandidateSource()) {
				const page = this.buildLocalMemberPage('');
				this.page.sourceTotal = page.total;
				return this.page.sourceTotal;
			}
			const params = new URLSearchParams();
			params.set('limit', '1');
			const page = await this.$http({
				url: `/group/${this.group.id}/member-candidates/${this.action}?${params.toString()}`,
				method: 'get'
			}).then(normalizeCandidatePage);
			this.page.sourceTotal = page.total;
			return this.page.sourceTotal;
		},
		ok() {
			this.$emit("complete", this.buildSelectionResult());
			this.isShow = false;
		},
		buildSelectionResult() {
			if (this.allSelected) {
				return {
					selectionMode: 'ALL',
					excludedUserIds: this.excludedUserIds,
					count: this.checkCount,
					items: this.checkedMembers
				};
			}
			return this.checkedMembers;
		},
		close() {
			this.searchText = "";
			this.isShow = false;
		},
		async loadMembers({ reset = false } = {}) {
			if (!this.group || !this.group.id) {
				this.members = [];
				return;
			}
			if (!reset && (!this.page.more || !this.page.cursor || this.page.loadingMore)) {
				return;
			}
			const seq = ++this.loadSeq;
			const keyword = this.normalizedSearchText;
			if (reset) {
				this.members = [];
				this.page.cursor = '';
				this.page.more = false;
				this.page.total = 0;
				if (!keyword) {
					this.page.sourceTotal = 0;
				}
				this.page.keyword = keyword;
				this.page.loading = true;
			} else {
				this.page.loadingMore = true;
			}
			try {
				const page = await this.fetchMemberPage({
					cursor: reset ? '' : this.page.cursor,
					keyword
				});
				if (seq !== this.loadSeq || !this.isShow) {
					return;
				}
				const rows = page.items.map(member => this.mapMemberRow(member));
				this.members = reset ? rows : this.mergeMemberRows(this.members, rows);
				this.page.cursor = page.cursor;
				this.page.more = page.more;
				this.page.total = page.total;
				if (!keyword) {
					this.page.sourceTotal = page.total;
				}
				this.page.keyword = keyword;
			} catch (error) {
				console.warn('GroupMemberSelector 加载成员候选失败', error);
				if (this.isShow) {
					this.$message.error('加载成员列表失败');
				}
			} finally {
				if (seq === this.loadSeq) {
					this.page.loading = false;
					this.page.loadingMore = false;
				}
			}
		},
		async fetchMemberPage({ cursor = '', keyword = '' } = {}) {
			if (!REMOTE_ACTIONS.has(this.action)) {
				await this.ensureDefaultMembersReady();
			}
			if (this.canUseRemoteCandidateSource()) {
				const params = new URLSearchParams();
				params.set('limit', String(CANDIDATE_PAGE_LIMIT));
				if (cursor) {
					params.set('cursor', cursor);
				}
				if (keyword) {
					params.set('keyword', keyword);
				}
				return this.$http({
					url: `/group/${this.group.id}/member-candidates/${this.action}?${params.toString()}`,
					method: 'get'
				}).then(normalizeCandidatePage);
			}
			return normalizeCandidatePage(this.buildLocalMemberPage(keyword));
		},
		canUseRemoteCandidateSource() {
			if (!REMOTE_ACTIONS.has(this.action)) {
				return false;
			}
			// Mute state can change outside this client's complete member snapshot.
			// Always let the server filter mute/unmute candidates against persisted state.
			if (AUTHORITATIVE_CANDIDATE_ACTIONS.has(this.action)) {
				return true;
			}
			return !this.groupStore.hasCompleteMemberSnapshot(this.group.id);
		},
		async ensureDefaultMembersReady() {
			const runtimeGroup = this.groupStore.findGroup(this.group.id);
			if (runtimeGroup && Array.isArray(runtimeGroup.members) && runtimeGroup.members.length > 0) {
				return;
			}
			await this.groupStore.refreshMember(this.group.id, {
				refreshOnline: false,
				pageLimit: 30
			}).catch(() => []);
		},
		buildLocalMemberPage(keyword) {
			const normalizedKeyword = String(keyword || '').trim().toLowerCase();
			const group = this.groupStore.findGroup(this.group.id) || this.group;
			const ownerId = this.group.ownerId;
			const selfId = this.userStore.userInfo && this.userStore.userInfo.id;
			const isOwner = ownerId == selfId;
			const items = ((group && group.members) || []).filter((member) => {
				if (!member || member.quit || this.hiddenMap[String(member.userId)] || this.lockedMap[String(member.userId)]) {
					return false;
				}
				if (REMOTE_ACTIONS.has(this.action)) {
					if (member.userId == ownerId) {
						return false;
					}
					if (member.userId == selfId) {
						return false;
					}
					if (!isOwner && member.isManager) {
						return false;
					}
					if (this.action === 'mute' && member.isMuted) {
						return false;
					}
					if (this.action === 'unmute' && !member.isMuted) {
						return false;
					}
				}
				if (!normalizedKeyword) {
					return true;
				}
				return matchesContactKeyword(member, normalizedKeyword);
			});
			return {
				items,
				cursor: '',
				more: false,
				total: items.length
			};
		},
		mapMemberRow(member) {
			const row = { ...member };
			const key = resolveIdKey(row.userId);
			row.locked = Boolean(this.lockedMap[key]);
			row.hide = Boolean(this.hiddenMap[key]);
			row.checked = this.isMemberChecked(row);
			attachContactSearchText(row);
			if (row.checked && !this.allSelected) {
				this.$set(this.selectedItems, key, row);
			}
			return row;
		},
		mergeMemberRows(oldRows, newRows) {
			const seen = new Set();
			const rows = [];
			oldRows.concat(newRows).forEach((member) => {
				const key = resolveIdKey(member && member.userId);
				if (!key || seen.has(key)) {
					return;
				}
				seen.add(key);
				member.checked = this.isMemberChecked(member);
				rows.push(member);
			});
			return rows;
		},
		async ensureCheckedWindowHydratedForAllSelected() {
			if (!this.allSelected) {
				return;
			}
			const targetSize = Math.max(CHECKED_RESULT_PAGE_SIZE, Math.floor(Number(this.checkedViewLimit) || 0));
			while (this.isShow && this.allSelected && this.checkedMembers.length < targetSize) {
				if (this.page.loading || this.page.loadingMore || !this.page.more || !this.page.cursor) {
					break;
				}
				const beforeLength = this.checkedMembers.length;
				const beforeCursor = this.page.cursor;
				await this.loadMembers({ reset: false });
				if (this.checkedMembers.length <= beforeLength && this.page.cursor === beforeCursor) {
					break;
				}
			}
		},
			onMemberListReachBottom() {
				this.loadMembers({ reset: false });
			},
			async onCheckedListReachBottom() {
				const nextLimit = Math.max(CHECKED_RESULT_PAGE_SIZE, Math.floor(Number(this.checkedViewLimit) || 0)) + CHECKED_RESULT_PAGE_SIZE;
				const maxCount = Math.max(this.checkCount, this.checkedMembers.length);
				this.checkedViewLimit = Math.min(maxCount, nextLimit);
				if (this.allSelected) {
					await this.ensureCheckedWindowHydratedForAllSelected();
				}
			}
		},
	computed: {
		isMobileView() {
			return this.configStore.isMobile;
		},
		dialogWidth() {
			return this.configStore.isMobile ? '100%' : '680px';
		},
		normalizedSearchText() {
			return String(this.searchText || '').trim();
		},
		memberRowHeight() {
			return 50;
		},
		selectedUserIds() {
			return Object.keys(this.selectedMap).map(key => Number(this.selectedMap[key])).filter(id => id > 0);
		},
		excludedUserIds() {
			return Object.keys(this.excludedMap).map(key => Number(this.excludedMap[key])).filter(id => id > 0);
		},
			checkedMembers() {
				if (this.allSelected) {
					return this.members.filter(member => this.isMemberChecked(member));
				}
				return Object.keys(this.selectedItems)
					.map(key => this.selectedItems[key])
					.filter(Boolean);
			},
			checkedMembersView() {
				const limit = Math.max(CHECKED_RESULT_PAGE_SIZE, Math.floor(Number(this.checkedViewLimit) || 0));
				if (this.checkedMembers.length <= limit) {
					return this.checkedMembers;
				}
				return this.checkedMembers.slice(0, limit);
			},
			removableCheckedCount() {
				return this.checkCount;
			},
		showMembers() {
			return this.members.filter((m) => m && !m.hide && !m.quit && !m.locked);
		},
		selectableMemberTotalCount() {
			return Math.max(0, Math.floor(Number(this.page.sourceTotal || this.page.total || 0)));
		},
			checkCount() {
				if (this.allSelected) {
					const sourceTotal = Math.max(0, Math.floor(Number(this.page.sourceTotal || this.page.total || 0)));
					return Math.max(sourceTotal - this.excludedUserIds.length, 0);
				}
				return this.selectedUserIds.length;
			},
			isAllVisibleChecked() {
				return this.selectableMemberTotalCount > 0 && this.checkCount === this.selectableMemberTotalCount;
			},
			isSelectAllIndeterminate() {
				return this.checkCount > 0 && this.checkCount < this.selectableMemberTotalCount;
			},
		allVisibleCheckedProxy: {
			get() {
				return this.isAllVisibleChecked;
			},
			set(checked) {
				this.onToggleGlobalSelectAll(checked);
			}
		},
		currentEmptyTitle() {
			if (this.page.loading) {
				return '加载中';
			}
			if (this.normalizedSearchText) {
				return '无结果';
			}
			return '暂无可选成员';
		}
	},
	watch: {
		searchText() {
			if (!this.isShow) {
				return;
			}
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
			}
			this.searchTimer = setTimeout(() => {
				this.searchTimer = null;
				this.loadMembers({ reset: true });
			}, 260);
		}
	}
}
</script>

<style lang="scss" scoped>
.group-member-selector {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(196px, 220px);
	gap: 8px;
	height: min(416px, calc(100vh - 188px));
	min-height: 0;
	overflow: hidden;

	.panel-head {
		display: flex;
		flex-direction: column;
		gap: 6px;
		padding: 10px 12px 8px;
		border-bottom: 1px solid var(--im-surface-panel-border);
		flex-shrink: 0;
	}

	.panel-title {
		font-size: 14px;
		font-weight: 600;
		color: var(--im-text-color);
		text-align: left;
	}

	.compact-title {
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}

	.result-badge,
	.inline-count {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 22px;
		height: 22px;
		padding: 0 6px;
		border-radius: 999px;
		background: rgba(var(--im-primary-rgb), 0.08);
		color: var(--im-color-primary);
		font-size: 12px;
		font-weight: 600;
	}

	.scroll-box {
		flex: 1;
		min-height: 0;
	}

	.select-tools {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
		min-height: 32px;
	}

	.select-tools__actions {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		margin-left: auto;
	}

	.list-empty-state {
		height: 100%;
	}

	::v-deep .el-scrollbar__wrap {
		overflow-x: hidden;
	}

	.left-box,
	.right-box {
		overflow: hidden;
		border: 1px solid var(--im-surface-panel-border);
		border-radius: 10px;
		background: transparent;
		display: flex;
		flex-direction: column;
		min-height: 0;
	}

	.left-box {
		::v-deep .virtual-scroller {
			height: 100%;
		}

		::v-deep .virtual-content {
			padding: 4px 0;
		}
	}

	.right-box {
		.selection-head {
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
		}

		.icon-btn {
			padding: 4px;
		}

		.clear-btn {
			color: var(--im-text-color-light);
		}

		.compact-empty {
			padding: 18px 12px;
		}

		.checked-scroll-box {
			::v-deep .virtual-content {
				padding: 6px;
				box-sizing: border-box;
			}
		}

		.checked-item {
			display: flex;
			align-items: center;
			gap: 8px;
			padding: 8px 10px;
			border-radius: 8px;
			border: 1px solid var(--im-control-border);
			background: var(--im-control-soft-bg);
			cursor: pointer;
			transition: background-color 0.2s ease, border-color 0.2s ease;

			.checked-main {
				flex: 1;
				min-width: 0;
				text-align: left;
			}

			.checked-name {
				font-size: var(--im-font-size);
				font-weight: 600;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.checked-meta {
				display: flex;
				flex-wrap: wrap;
				gap: 4px;
				margin-top: 4px;
			}

			.state-tag {
				display: inline-flex;
				align-items: center;
				height: 18px;
				padding: 0 6px;
				border-radius: 999px;
				background: rgba(var(--im-primary-rgb), 0.08);
				color: var(--im-color-primary);
				font-size: 11px;
				line-height: 1;

				&.danger {
					background: rgba(239, 68, 68, 0.1);
					color: #dc2626;
				}

				&.warning {
					background: rgba(245, 158, 11, 0.12);
					color: #b45309;
				}
			}

			.close {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 22px;
				height: 22px;
				border-radius: 7px;
				color: var(--im-text-color-light);
				flex-shrink: 0;
				transition: background-color 0.2s ease, color 0.2s ease;
			}

			&:hover {
				background: rgba(var(--im-primary-rgb), 0.05);
				border-color: rgba(var(--im-primary-rgb), 0.12);

				.close {
					background: rgba(var(--im-primary-rgb), 0.12);
					color: var(--im-text-color);
				}
			}
		}
	}

	&.is-mobile {
		grid-template-columns: 1fr;
		grid-template-rows: minmax(0, 1fr) auto;
		gap: 8px;
		height: min(560px, calc(100vh - 232px));

		.left-box,
		.right-box {
			border-radius: 8px;
		}

		.right-box {
			min-height: 96px;

			.scroll-box {
				min-height: 64px;
				max-height: 82px;
			}

			::v-deep .virtual-scroller {
				overflow-x: auto;
				overflow-y: hidden;
			}

			::v-deep .virtual-content {
				display: flex;
				gap: 8px;
				min-width: 100%;
				padding: 0 2px;
			}

			.checked-item {
				flex: 0 0 172px;
			}
		}
	}
}

.group-member-selector-shell {
	::v-deep .group-member-selector-dialog {
		max-height: calc(100vh - 24px);
		display: flex;
		flex-direction: column;
		overflow: hidden;
		width: min(720px, calc(100vw - 24px)) !important;
		border-radius: 8px;
		border: 1px solid var(--im-surface-panel-border);
		box-shadow: 0 14px 30px -22px rgba(var(--im-black-rgb), 0.34);
	}

	::v-deep .el-dialog__body {
		flex: 1;
		min-height: 0;
		overflow: hidden;
		padding: 10px 16px 12px;
	}

	::v-deep .el-dialog__footer {
		flex-shrink: 0;
		padding: 10px 16px 16px;
		border-top: 1px solid var(--im-surface-panel-border);
	}

	::v-deep .el-dialog__footer .el-button {
		min-width: 88px;
		border-radius: 8px;
	}
}

@media (max-width: 640px) {
	.group-member-selector-shell {
		display: flex;
		align-items: flex-end;
		padding: 0;
		overflow: hidden;

		::v-deep .group-member-selector-dialog {
			width: calc(100vw - 12px) !important;
			max-height: min(720px, calc(100vh - 72px));
			margin: 0 auto 6px !important;
			border-radius: 8px 8px 0 0;
		}

		::v-deep .el-dialog__body {
			padding: 8px 12px 10px;
		}

		::v-deep .el-dialog__footer {
			padding: 8px 12px calc(10px + env(safe-area-inset-bottom));
		}
	}

	.selector-footer {
		display: grid;
		grid-template-columns: 92px minmax(0, 1fr);
		gap: 8px;
		width: 100%;
	}
}
</style>
